import { isFreshWizardEntry } from "~/components/_refactored/requestTenderPage/request-tender-page-modules/autoSkipGuard";

export const TENDER_ORIGIN_STORAGE_KEY = "joszaki-tender-origin";

function parseUrl(url) {
  try {
    return new URL(url);
  } catch (error) {
    return null;
  }
}

function isWizardUrl(url, toRoute) {
  const parsed = parseUrl(url);
  const wizardBasePath = (toRoute?.path || "").replace(/\/\d+\/?$/, "");
  return Boolean(parsed && wizardBasePath) && parsed.pathname.startsWith(wizardBasePath);
}

function isOwnPage(url, origin) {
  const parsed = parseUrl(url);
  return Boolean(parsed) && parsed.origin === origin;
}

/**
 * Resolves the page a tender request was initiated from (persisted as
 * `tender.from_url`). Priority:
 *   1. an explicit ?fromUrl= (legacy window.open flow, landings)
 *   2. the origin already recorded for this wizard session, when the visitor
 *      is moving between steps or reloading a step (never on a fresh entry,
 *      so a previous tender's origin cannot leak into a new one)
 *   3. the route the visitor navigated from (SPA entry into the wizard)
 *   4. a same-origin document.referrer (full page load from one of our pages)
 *   5. the current URL (direct entry / deep link)
 */
export function resolveTenderOrigin({
  queryFromUrl,
  storedFromUrl,
  fromRoute,
  toRoute,
  origin,
  currentHref,
  referrer,
}) {
  if (queryFromUrl) {
    return queryFromUrl;
  }

  const continuesWizard = fromRoute?.name
    ? !isFreshWizardEntry(fromRoute.name, toRoute?.name)
    : isOwnPage(referrer, origin) && isWizardUrl(referrer, toRoute);

  if (continuesWizard && storedFromUrl) {
    return storedFromUrl;
  }

  if (fromRoute?.name && !continuesWizard && fromRoute.fullPath) {
    return `${origin}${fromRoute.fullPath}`;
  }

  if (isOwnPage(referrer, origin) && !isWizardUrl(referrer, toRoute)) {
    return referrer;
  }

  return currentHref;
}

export function readStoredTenderOrigin() {
  try {
    return window.sessionStorage.getItem(TENDER_ORIGIN_STORAGE_KEY);
  } catch (error) {
    return null;
  }
}

export function storeTenderOrigin(url) {
  try {
    window.sessionStorage.setItem(TENDER_ORIGIN_STORAGE_KEY, url);
  } catch (error) {}
}
